export default "__VITE_ASSET__Cgqhobk5__"